import styled from 'styled-components';

const StyledSpan = styled.span`
  color: red;
  display: inline-block;
  margin: 0 5px 0 0;
  text-transform: uppercase;
  font: var(--font-bold);
`;

const StyledDiv = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
`;

export { StyledSpan, StyledDiv };
